export default __webpack_public_path__ + "static/media/twitter-icon.b063af61.svg";